// extracted by mini-css-extract-plugin
export default {"header":"styles_header__3H5G7","body":"styles_body__feO0A"};